import { render, staticRenderFns } from "./CandidateDetails.vue?vue&type=template&id=917bbd4c&scoped=true&"
import script from "./CandidateDetails.vue?vue&type=script&lang=js&"
export * from "./CandidateDetails.vue?vue&type=script&lang=js&"
import style0 from "./CandidateDetails.vue?vue&type=style&index=0&id=917bbd4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "917bbd4c",
  null
  
)

export default component.exports